module.exports = "/_next/static/images/Hero-md-1ce2a1c5aca79881ab3802bf7c476c51.webp";